/** Concluir e cobrar (função 5): usado pelo painel Agora e pela folha do atendimento. */
import { type PaymentMethod, type SaleItemInput, PAYMENT_LABELS, amountDue, formatMoney } from '@lindeza/core';
import { useRuntime } from '@lindeza/core/hooks';
import { toast, toastError, withUndo } from '../../app/ui';

export function useComplete() {
  const rt = useRuntime();
  /** `products`: o que ela vendeu do estoque junto, cobrado na mesma forma de pagamento. */
  return async (id: string, method: PaymentMethod | null, discountCents = 0, products: SaleItemInput[] = []): Promise<boolean> => {
    try {
      const r = await rt.actions.completeAppointment(id, { method, discountCents, products });
      const saleCents = r.sale?.total_cents ?? 0;
      const text = r.packageUsed
        ? `Concluído · pacote: ${r.packageUsed.remaining === 0 ? 'acabou o saldo!' : `faltam ${r.packageUsed.remaining}`}`
        : method
          ? `Concluído · ${PAYMENT_LABELS[method]} ${formatMoney((r.payment?.amount_cents ?? 0) + saleCents)}`
          : `Concluído · ${formatMoney(amountDue(r.appointment) + saleCents)} a receber`;
      withUndo(text, async () => {
        await rt.actions.reverseCompletion(id);
        toast('Conclusão desfeita.');
      });
      return true;
    } catch (e) {
      toastError(e);
      return false;
    }
  };
}
